<template>
  <section class="direct-access">
    <div class="direct-access shadow-10">
      <div class="direct-access-content">
        <h4>Accesos directos</h4>
        <p class="direct-access-placeholder">
          Accede de forma directa a tus herramientas para realizar gestiones
        </p>
        <div class="container-direct-access">
          <div class="direct-access-item">
            <a href="" target="_blank"
              ><span class="access-direct-span">Ir a Salesforce </span
              ><span class="icon icon-chevron-right"></span
            ></a>
          </div>
          <div class="direct-access-item" v-if="user.source === 'shops'">
            <a href="http://mpm-new.rastreator.net/" target="_blank"
              ><span class="access-direct-span">Ir a MPM</span
              ><span class="icon icon-chevron-right"></span
            ></a>
          </div>
          <div class="direct-access-item">
            <a href="https://dashboard.rastreator.com/" target="_blank"
              ><span class="access-direct-span">Ir a Dashboard</span
              ><span class="icon icon-chevron-right"></span
            ></a>
          </div>
          <div class="direct-access-item">
            <a href="https://businessportal.rastreator.com" target="_blank"
              ><span class="access-direct-span">Ir a Business Portal</span
              ><span class="icon icon-chevron-right"></span
            ></a>
          </div>
          <div class="direct-access-item">
            <a href="http://intranet.rastreator.net/" target="_blank"
              ><span class="access-direct-span">Ir a Intranet</span
              ><span class="icon icon-chevron-right"></span>
            </a>
          </div>
          <div class="direct-access-item">
            <a
              href="https://sites.google.com/rvu.es/atc-tiendas-rtr/home"
              target="_blank"
              ><span class="access-direct-span">Biblioteca General</span
              ><span class="icon icon-chevron-right"></span>
            </a>
          </div>
          <div class="direct-access-item" v-if="user.source === 'shops'">
            <a
              href="https://docs.google.com/spreadsheets/d/1UQ2DsOgksB9eg8cU5nfJKQVghXelGK9c/edit#gid=29242335"
              target="_blank"
              ><span class="access-direct-span">Biblioteca Correduría</span
              ><span class="icon icon-chevron-right"></span>
            </a>
          </div>
          <div class="direct-access-item" v-if="user.source === 'shops'">
            <a href="https://drive.google.com/drive/u/0/folders/0AN-vV448MRRLUk9PVA" target="_blank"
              ><span class="access-direct-span">Compañías Salud (Info & Docs)</span
              ><span class="icon icon-chevron-right"></span>
            </a>
          </div>
          <!-- <div class="direct-access-item" v-if="user.source === 'callcenter'">
            <a href="https://sites.google.com/rvu.es/atc-tiendas-rtr/home" target="_blank"
              ><span class="access-direct-span">Site Formación ATC</span
              ><span class="icon icon-chevron-right"></span>
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  data() {
    return{
    user: {}
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
  }
};
</script>

<style lang="scss">
@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";

.direct-access {
  background-color: $color-white;
  margin-bottom: 40px;
  .direct-access-content {
    padding: 8px 73px 30px;
    h4 {
      @include text($size: 23px, $color: $color-blue-02, $lineheight: 22px, $weight: 600);
      margin-bottom: 15px;
      text-align: left;
      cursor: default;
    }
    .direct-access-placeholder {
      @include text($size: 16px, $color: $color-grey-03, $lineheight: 1.47);
      margin-bottom: -9px;
      position: relative;
      cursor: default;
      &::after {
        right: -12px;
        width: calc(100% - -15px);
        height: 1px;
        position: absolute;
        content: "";
        background: $color-grey-04;
        top: 29px;
      }
    }

    .container-direct-access {
      display: flex;
      flex-wrap: wrap;
      margin: 0 0 12px;
      margin-top: 59px;
      .direct-access-item {
        margin-bottom: 42px;
        a {
          border: 2px solid $color-grey-06;
          border-radius: 4px;
          padding: 16px 31px 16px 18px;
          margin-right: 35px;
          color: $color-blue-04;
          font-weight: 600;
          text-decoration: none;
          box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
          &:hover {
            transition: 0.4s;
            color: $color-white;
            border: 2px solid $color-blue-02;
            background-color: $color-blue-02;
          }
        }
        .icon.icon-chevron-right {
          font-size: 20px;
          font-weight: 600;
          position: relative;
          top: 6px;
          left: 12px;
        }
      }
    }
  }
}
</style>
